// import { initAlpine } from './alpine';

import './style.scss';

// import './blocks/accordion-details-summary/view';
// import './blocks/accordion-group/view';
import './blocks/query-taxonomy-filter/view';
import './blocks/query-post-date-filter/view';
import './blocks/query-filter-container/view';
// import './blocks/carousel/v2/GalleryCarousel/view';
import './blocks/tab-layout/view';

console.log(`[mbm-gutenblocks] front.js loaded`)
